/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { masterDbPingDebugMasterDbGet } from '../fn/debug/master-db-ping-debug-master-db-get';
import { MasterDbPingDebugMasterDbGet$Params } from '../fn/debug/master-db-ping-debug-master-db-get';
import { BackendMasterDbPingResponseDto } from '../models/backend-master-db-ping-response-dto';
import { serviceDbPingDebugServiceDbGet } from '../fn/debug/service-db-ping-debug-service-db-get';
import { ServiceDbPingDebugServiceDbGet$Params } from '../fn/debug/service-db-ping-debug-service-db-get';
import { BackendServiceDbPingResponseDto } from '../models/backend-service-db-ping-response-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiDebugService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `masterDbPingDebugMasterDbGet()` */
  static readonly MasterDbPingDebugMasterDbGetPath = '/debug/master-db';

  /**
   * Smoke-тест master-БД (read-only).
   *
   * Проверяет подключение к master-БД, что транзакции read-only, и что таблица `projects_project` доступна.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDbPingDebugMasterDbGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDbPingDebugMasterDbGet$Response(
    params?: MasterDbPingDebugMasterDbGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMasterDbPingResponseDto>> {
    return masterDbPingDebugMasterDbGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Smoke-тест master-БД (read-only).
   *
   * Проверяет подключение к master-БД, что транзакции read-only, и что таблица `projects_project` доступна.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDbPingDebugMasterDbGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDbPingDebugMasterDbGet(
    params?: MasterDbPingDebugMasterDbGet$Params,
    context?: HttpContext,
  ): Observable<BackendMasterDbPingResponseDto> {
    return this.masterDbPingDebugMasterDbGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMasterDbPingResponseDto>): BackendMasterDbPingResponseDto => r.body),
    );
  }

  /** Path part for operation `serviceDbPingDebugServiceDbGet()` */
  static readonly ServiceDbPingDebugServiceDbGetPath = '/debug/service-db';

  /**
   * Smoke-тест service-БД (read-write).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceDbPingDebugServiceDbGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceDbPingDebugServiceDbGet$Response(
    params?: ServiceDbPingDebugServiceDbGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendServiceDbPingResponseDto>> {
    return serviceDbPingDebugServiceDbGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Smoke-тест service-БД (read-write).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceDbPingDebugServiceDbGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceDbPingDebugServiceDbGet(
    params?: ServiceDbPingDebugServiceDbGet$Params,
    context?: HttpContext,
  ): Observable<BackendServiceDbPingResponseDto> {
    return this.serviceDbPingDebugServiceDbGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendServiceDbPingResponseDto>): BackendServiceDbPingResponseDto => r.body),
    );
  }
}
